<div class="tab-inner-content">
  <h2>Trial Balance</h2>
  <h5>
    From {{ startDate | date : "MM/d/YYYY" }} to
    {{ endDate | date : "MM/d/YYYY" }}
  </h5>
  <table>
    <tr>
      <th>Account Name</th>
      <th>Account Type</th>
      <th>Net Debit (In AED)</th>
      <th>Net Credit (In AED)</th>
    </tr>
    <!-- Accounts Under Category -->
    <tr class="sub-total" *ngFor="let account of trialBalanceReport?.accounts">
      <td>{{ account.accountName }}</td>
      <td>{{ account.accountType }}</td>
      <td>{{ account.totalDebit | number : "1.2-2" }}</td>
      <td>{{ account.totalCredit | number : "1.2-2" }}</td>
    </tr>
    <tr *ngIf="trialBalanceReport?.accounts?.length !== 0" class="title">
      <td>Total for Trial Balance</td>
      <td></td>
      <td>AED {{ trialBalanceReport?.totalDebit | number : "1.2-2" }}</td>
      <td>AED {{ trialBalanceReport?.totalCredit | number : "1.2-2" }}</td>
    </tr>
    <tr *ngIf="trialBalanceReport?.accounts?.length === 0">
      <td colspan="4" class="no-data">
        No data available
      </td>
    </tr>
  </table>
</div>
